<!-- Кнопки управления выбранным значением и индикатор открытия BaseSelect. -->
<template>
  <div class="select-controls">
    <button
      v-if="hasSelection && editable && !disabled"
      class="edit-button"
      type="button"
      :title="editTitle"
      :aria-label="editTitle"
      @click.stop="$emit('edit')"
    >
      <AppIcon name="edit" :size="14" />
    </button>

    <!-- Кнопка очистки -->
    <button
      v-if="hasSelection && clearable && !disabled"
      class="clear-button"
      type="button"
      @click.stop="$emit('clear')"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="currentColor"
      >
        <path
          d="M1 1l12 12M13 1L1 13"
          stroke="currentColor"
          stroke-width="1"
        />
      </svg>
    </button>

    <span class="select-arrow" :class="{ 'is-open': isOpen }">
      <svg
        width="16"
        height="12"
        viewBox="0 0 12 8"
        fill="currentColor"
      >
        <path
          d="M1 1l5 5 5-5"
          stroke="currentColor"
          stroke-width="1"
          fill="none"
        />
      </svg>
    </span>
  </div>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "BaseSelectControls",

  components: {
    AppIcon,
  },

  props: {
    hasSelection: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    editTitle: {
      type: String,
      default: "Редактировать",
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["edit", "clear"],
};
</script>

<style scoped>
.select-controls {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
}

.edit-button,
.clear-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  color: #999;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.2s ease;
  padding: 0;
}

.edit-button {
  color: #8b949e;
}

.edit-button:hover {
  background: #eef7f6;
  color: var(--color-green);
}

.clear-button:hover {
  background: #fef2f2;
  color: var(--color-danger);
}

.select-arrow {
  display: flex;
  align-items: center;
  color: #999;
  transition: transform 0.2s ease;
}

.select-arrow svg {
  width: 14px;
  height: 10px;
}

.select-arrow.is-open {
  transform: rotate(180deg);
}
</style>
